/* @flow */

import * as React from 'react';

export default function useMobileKeyboardVisibility(): boolean {
  /*
   |----------------------------------------------------------------------------
   | State
   |----------------------------------------------------------------------------
   */

  const [wasTouched, setTouched] = React.useState(false);
  const [isKeyboardShown, setKeyboardShown] = React.useState(false);
  const [initialHeight] = React.useState(
    typeof window !== 'undefined' ? window.innerHeight : 0,
  );

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    window.addEventListener('touchstart', onTouchStart);

    return () => {
      window.removeEventListener('touchstart', onTouchStart);
    };
  }, []);

  React.useEffect(() => {
    if (wasTouched) {
      window.addEventListener('resize', onResize);

      return () => {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [wasTouched]);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onTouchStart = () => {
    window.removeEventListener('touchstart', onTouchStart);

    setTouched(true);
  };

  const onResize = () => setKeyboardShown(window.innerHeight < initialHeight);

  return isKeyboardShown;
}
